module.exports = __webpack_public_path__ + "static/media/ml-in-data-science-interviews.df01fe90.md";